/**
 * Bunny Hopping Animation for Shopify Dawn Theme
 * LittleOkieStudio
 */

(function() {
  'use strict';

  // Configuration - REPLACE THE IMAGE URL WITH YOUR BUNNY IMAGE!
  const CONFIG = {
    bunnyImageUrl: 'https://cdn.shopify.com/s/files/1/0592/8753/5700/files/Untitled_Artwork.png?v=1772325073',
    animationDuration: 2200,
    hopHeights: [120, 90, 60],
    bunnySize: 128
  };

  function createBunnyElement() {
    const bunny = document.createElement('div');
    bunny.id = 'hopping-bunny';
    bunny.style.cssText = `
      position: fixed;
      width: ${CONFIG.bunnySize}px;
      height: ${CONFIG.bunnySize}px;
      pointer-events: none;
      z-index: 9999;
      opacity: 0;
      transition: none;
    `;

    const img = document.createElement('img');
    img.src = CONFIG.bunnyImageUrl;
    img.style.cssText = `
      width: 100%;
      height: 100%;
      object-fit: contain;
      filter: drop-shadow(0 4px 8px rgba(0,0,0,0.15));
    `;
    
    bunny.appendChild(img);
    document.body.appendChild(bunny);
    
    return bunny;
  }

  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  function calculateHopY(progress) {
    const hopTimes = [0, 0.15, 0.3, 0.5, 0.65, 0.85, 1];
    const hopValues = [0, -CONFIG.hopHeights[0], 0, -CONFIG.hopHeights[1], 0, -CONFIG.hopHeights[2], 0];
    
    for (let i = 0; i < hopTimes.length - 1; i++) {
      if (progress >= hopTimes[i] && progress <= hopTimes[i + 1]) {
        const segmentProgress = (progress - hopTimes[i]) / (hopTimes[i + 1] - hopTimes[i]);
        const eased = easeInOutQuad(segmentProgress);
        return hopValues[i] + (hopValues[i + 1] - hopValues[i]) * eased;
      }
    }
    return 0;
  }

  function animateBunny(startX, startY, endX, endY) {
    const bunny = document.getElementById('hopping-bunny') || createBunnyElement();
    
    const startTime = Date.now();
    
    bunny.style.left = startX + 'px';
    bunny.style.top = startY + 'px';
    bunny.style.transform = 'translate(-50%, -50%) scale(1)';
    bunny.style.opacity = '1';

    function animate() {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / CONFIG.animationDuration, 1);

      const currentX = startX + (endX - startX) * easeInOutQuad(progress);
      const currentY = startY + (endY - startY) * easeInOutQuad(progress);
      const hopOffset = calculateHopY(progress);

      let scale = 1;
      if (progress > 0.65) {
        const shrinkProgress = (progress - 0.65) / 0.35;
        scale = 1 - (shrinkProgress * 0.8);
      }

      const opacity = progress > 0.85 ? 1 - ((progress - 0.85) / 0.15) : 1;

      bunny.style.left = currentX + 'px';
      bunny.style.top = (currentY + hopOffset) + 'px';
      bunny.style.transform = `translate(-50%, -50%) scale(${scale})`;
      bunny.style.opacity = opacity;

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        bunny.style.opacity = '0';
      }
    }

    animate();
  }

  function handleAddToCart(event) {
    const button = event.currentTarget;
    const buttonRect = button.getBoundingClientRect();
    
    const cartIcon = document.querySelector('#cart-icon-bubble') || 
                     document.querySelector('.header__icon--cart') ||
                     document.querySelector('[href="/cart"]');
    
    if (!cartIcon) {
      return;
    }

    const cartRect = cartIcon.getBoundingClientRect();
    
    const startX = buttonRect.left + buttonRect.width / 2;
    const startY = buttonRect.top + buttonRect.height / 2;
    const endX = cartRect.left + cartRect.width / 2;
    const endY = cartRect.top + cartRect.height / 2;

    animateBunny(startX, startY, endX, endY);
  }

  function init() {
    const addToCartButtons = document.querySelectorAll(
      'button[name="add"], .product-form__submit, [type="submit"][name="add"]'
    );

    addToCartButtons.forEach(button => {
      button.addEventListener('click', handleAddToCart);
    });

    document.addEventListener('submit', function(event) {
      if (event.target.matches('.product-form form, form[action="/cart/add"]')) {
        const form = event.target;
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
          const fakeEvent = { currentTarget: submitButton };
          handleAddToCart(fakeEvent);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
function quickAddToCart(event, button) {
  event.preventDefault();
  event.stopPropagation();
  
  const productId = button.getAttribute('data-product-id');
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: productId,
      quantity: 1
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Added to cart:', data);
    animateBunny(button);
    updateCartCount();
  })
  .catch(error => {
    console.error('Error:', error);
    alert('Sorry, there was an error adding this to your cart.');
  });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.cart-count-bubble span');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
      });
    });
}